<import from="../three-canvas/three-canvas"></import>
<div class="middle_body">
    <three-canvas></three-canvas>
</div>